import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

import logo from "../../../assets/images/logo_nsf.png";
import "./jo.css";

import dayjs from "dayjs";
import { parameterJODetailColumnPrint } from "../../../pages/ERP/joborder/model";

import JobOrderService from "../../../service/ERP/JobOrder.service";
import { Button, Card, Space, Table, Typography, Flex, Row, Col } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { PiPrinterFill } from "react-icons/pi";
import { capitalizeFirst, formatMoney } from "../../../utils/util";
const joService = JobOrderService();
function JoPrintPreview() {
  const { code, version } = useParams();
  const componentRef = useRef(null);
  const pagesRef = useRef(null);
  const printRef = useRef(null);

  const { Text } = Typography;
  const printStyleRef = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    content: () => pagesRef.current,
    onBeforeGetContent: () => {
      // With explicit 10-rows chunking we don't need height-based page breaking.

      // Scope JO print styles only during printing
      document.body.classList.add("jo-printing");
      const style = document.createElement("style");
      style.id = "jo-print-style";
      style.media = "print";
      style.innerHTML = `
        @page { size: A4 landscape; margin: 0; }
        @media print {
          body.jo-printing .jo-page-form #form-head,
          body.jo-printing .jo-page-form #form-body-header,
          body.jo-printing .jo-page-form #form-body-item,
          body.jo-printing .jo-page-form #form-body-last { page-break-inside: avoid; break-inside: avoid; page-break-before: auto; page-break-after: auto; }
        }
      `;
      document.head.appendChild(style);
      printStyleRef.current = style;
    },
    onAfterPrint: () => {
      // Remove JO-only print styles after printing
      document.body.classList.remove("jo-printing");
      if (printStyleRef.current) {
        try { printStyleRef.current.remove(); } catch (_) {}
        printStyleRef.current = null;
      }
      console.log("after printing...");
    },
    removeAfterPrint: true,
  });

  const [header, setHeader] = useState({});

  const [item_para, setItem_para] = useState([]);
  const [remark, setRemark] = useState([]);

  const handleBeforePrint = (e) => {
    // const newElement = document.createElement('div');
    // newElement.id = 'new-container'; // Optional: Set an ID for the new container
    // newElement.innerHTML = 'TEST';
    // Render the new component into the new container
    // Replace the old container with the new container
    // componentRef.current.innerHTML = 'TEST';
  };

  const handleCheckMultiPages = () => {
    const limitPage = 1000;

    const root = pagesRef.current;
    if (!root) return;

    const head = root.querySelector("#form-head");
    const parm =
      root.querySelector("#form-body-parm") ||
      root.querySelector("#form-body-item");
    const micro =
      root.querySelector("#form-body-micro") ||
      root.querySelector("#form-body-last");

    const getH = (el) => {
      if (!el) return 0;
      const h = window.getComputedStyle(el).getPropertyValue("height");
      return Number(h?.replace("px", "")) || 0;
    };

    let headH = getH(head);
    let parmH = getH(parm);
    let microH = getH(micro);

    if (headH + parmH + microH > limitPage && parm) {
      parm.style.pageBreakBefore = "always";
    }

    printRef.current = pagesRef.current;
    return printRef.current;
  };

  const itemChunks = useMemo(() => {
    const size = 10;
    const arr = item_para || [];
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks.length ? chunks : [[]];
  }, [item_para]);

  const grandTotals = useMemo(() => {
    const arr = item_para || [];
    const count = arr.length;
    const cartonTotal = arr.reduce((a, x) => (a += Number(x?.carton || 0)), 0);
    const unitTotal = arr.reduce(
      (a, x) => (a += Number(x?.carton || 0) * Number(x?.unit_cs || 0)),
      0
    );
    return { count, cartonTotal, unitTotal };
  }, [item_para]);

  const PrintComponent = ({ items, isLastPage }) => {
    return (
      <div className="jo-page-form">
        <table style={{ width: "100%", fontFamily: "inherit" }}>
          <thead>
            <tr>
              <th>
                <PrintHeaderPage />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr id="form-head">
              <td>
                <HeaderData />
              </td>
            </tr>
            <tr id="form-body-header">
              <td>
                <JobOrderItemsTable />
              </td>
            </tr>
            <tr id="form-body-item">
              <td>
                <BodyDataItem
                  items={items}
                  isLastPage={isLastPage}
                  grandTotals={grandTotals}
                />
              </td>
            </tr>
            <tr id="form-body-last">
              {isLastPage && (
                <td>
                  <LastData />
                </td>
              )}
            </tr>
            {/* <tr id="form-body-other">
                        <td><BodyDataOther /></td>
                    </tr>  */}
          </tbody>
          <tfoot>{isLastPage && <FooterForm />}</tfoot>
        </table>
      </div>
    );
  };

  const HeaderData = () => {
    return (
      <div
        className="head-data"
        style={{ marginBottom: 0, paddingBottom: 0, marginTop: 15 }}
      >
        <div className="flex">
          <div className="flex w-1/2 flex-col">
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 140, fontSize: 12 }}
              >
                Customer
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 12 }}>
                {/* {header.cuscode}  */}
                {header.cusname}
              </Typography.Text>
            </Space>
          </div>
          <div className="flex w-1/2 flex-col">
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 140, fontSize: 12 }}
              >
                Loading type
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 12 }}>
                {header.shipment}
              </Typography.Text>
              <Typography.Text
                strong
                style={{ display: "block", width: 140, fontSize: 12 }}
              >
                / Version:
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 12 }}>
                {header.version}
              </Typography.Text>
            </Space>
          </div>          
        </div>
        <div className="flex">          
          {/* <div className="flex w-1/2 flex-col">
            <Space className="w-full items-baseline">
              <Typography.Text
                strong
                style={{ display: "block", width: 140, fontSize: 12 }}
              >
                Job Order Date
              </Typography.Text>
              <Typography.Text style={{ display: "block", fontSize: 12 }}>
                {dayjs(header.jodate).format("DD/MM/YYYY")}
              </Typography.Text>
            </Space>
          </div> */}
        </div>
      </div>
    );
  };

  const LastData = () => {
    return (
      <div>
        <div className="flex">
          <div className="flex w-full flex-col">
            <Flex
              align="flex-start"
              justify="start"
              style={{ paddingBlock: "2mm" }}
            >
              <div      
              className="h-group-text"          
                style={{
                  flexDirection: "column",
                  width: "16.82cm",
                  justifyContent: "center",
                }}
              >
                ข้อกำหนดพิเศษ :
                <Flex justify="flex-start">
                  <span
                    className="c-text"
                    style={{ width: "25mm", fontWeight: 600 }}
                  >
                    {/* No */}
                  </span>
                  <span
                    className="c-text"
                    style={{ flexGrow: 1, fontWeight: 600 }}
                  >
                    {/* Remark */}
                  </span>
                </Flex>
                {(remark || []).length > 0 ? (
                  remark.map((r) => (
                    <Flex justify="flex-start" key={r.seq}>
                      {/* <span
                        className="c-text"
                        style={{ width: "25mm" }}
                      >
                        {r.seq}
                      </span> */}
                      <span style={{fontWeight:'normal'}}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{r.seq} &nbsp;&nbsp;&nbsp; {r.remark_detail}
                      </span>
                    </Flex>
                  ))
                ) : (
                  <Flex justify="start">
                    <span
                      className="c-text double-underline"
                      style={{
                        width: "100%",
                        justifyContent: "flex-end",
                        paddingBlock: "1rem",
                      }}
                    />
                  </Flex>
                )}
              </div>
            </Flex>
          </div>
        </div>
      </div>
    );
  };

  const BodyDataItem = ({ items, isLastPage, grandTotals }) => {
    return (
      <div className="body-data">
        <Card
          title={
            <div>
              <Typography.Text strong className="uppercase text-white">
                LIST ITEMS
              </Typography.Text>
            </div>
          }
          bordered={false}
        >
          <Table
            columns={parameterJODetailColumnPrint}
            dataSource={items}
            pagination={false}
            bordered={false}
            className="jo-grid-table"
            rowKey="id"
            summary={() => {
              if (!isLastPage || (items || []).length === 0) return null;

              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={5} align="right">
                    รวม{" "}
                    <span style={{ fontSize: "14px" }}>{grandTotals?.count || 0}</span>{" "}
                    รายการ
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    index={5}
                    className="text-summary text-end border-right-0 pe-summary"
                  >
                    <Text type="danger">
                      {formatMoney(grandTotals?.cartonTotal || 0, 0)}
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    index={7}
                    colSpan={2}
                    className="text-summary text-end border-right-0 pe-summary"
                  >
                    <Text type="danger">
                      {formatMoney(grandTotals?.unitTotal || 0, 0)}
                    </Text>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
            // showHeader={false}
          />
          <span style={{ fontSize: "12px" }}>{header.micro_description}</span>
        </Card>
      </div>
    );
  };

  const FooterForm = () => {
    return (
      <div className="print-foot" style={{ height: 60 }}>
        <div className="print-title flex justify-start">
          <Flex className="w-full" gap={16}>
            <Flex vertical className="w-3/4" style={{ gap: 10 }}>
              <Flex gap={2}>
                {/* <Typography.Text
                  className="tx-info"
                  strong
                  style={{ minWidth: 48 }}
                >
                  สร้างเอกสารโดย{" "}
                </Typography.Text>
                <Typography.Text className="tx-info">
                  {"\u00A0"}
                </Typography.Text>
              </Flex>
              <Flex gap={2}>
                <div
                  className="w-full"
                  style={{ height: 90, border: "1px solid var(---color--1)" }}
                >
                  {"\u00A0"}
                </div> */}
              </Flex>
            </Flex>
            <Flex vertical className="w-1/4" style={{ gap: 10 }}>
              <Flex gap={2}>
                <Typography.Text
                  className="tx-info"
                  strong
                  style={{ minWidth: 48 }}
                >
                  สร้างเอกสารโดย{" "}
                </Typography.Text>
                <Typography.Text className="tx-info" strong>
                  {"\u00A0"}
                </Typography.Text>
              </Flex>
              <Flex gap={2}>
                {header.created_name}
                {/* <div
                  className="w-full"
                  style={{ height: 90, border: "1px solid var(---color--1)" }}
                >
                  {"\u00A0"}
                </div> */}
              </Flex>
            </Flex>
          </Flex>
        </div>
      </div>
    );
  };

  const PrintHeaderPage = () => {
    return (
      <div className="flex w-full head-page" style={{ height: 70 }}>
        <div className="print-logo">
          <img src={logo} style={{ paddingInline: 6, marginLeft: 20 }} />
        </div>
        <div className="print-head" style={{ flex: 1 }}>
          <Typography.Title
            level={3}
            className="mb-0"
            style={{ textAlign: "right", margin: 15 }}
          >
            Job No {header.jocode} / 
            Date {dayjs(header.jodate).format("DD/MM/YYYY")}
          </Typography.Title>
        </div>
      </div>
    );
  };

  const JobOrderItemsTable = () => {
    return (
      <div className="jo-jo-wrapper" style={{ marginTop: 8 }}>
        <table className="jo-jo-table" cellSpacing={0} cellPadding={0}>
          <thead>
            <tr className="jo-jo-summary-row">
              <th>PO ลูกค้า</th>
              <th>Brand</th>
              <th>ETL</th>
              <th>ETD</th>
              <th>Actual ETD</th>
              <th>Actual ETL</th>
            </tr>
            <tr className="jo-jo-summary-value text-center">
              <td>{header.pi_no}</td>
              <td>{header.brand}</td>
              <td>
                {header.etl ? dayjs(header.etl).format("DD/MM/YYYY") : ""}
              </td>
              <td>
                {header.etd ? dayjs(header.etd).format("DD/MM/YYYY") : ""}
              </td>
              <td>
                {header.act_etd ? dayjs(header.act_etd).format("DD/MM/YYYY") : ""}
              </td>
              <td>
                {header.act_etl ? dayjs(header.act_etl).format("DD/MM/YYYY") : ""}
              </td>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    );
  };

  useEffect(() => {
    if (pagesRef.current) {
      const computedStyle = window.getComputedStyle(pagesRef.current);
      const heightWithUnit = computedStyle.getPropertyValue("height");

      console.log("Component height:", heightWithUnit);
    }
  }, []);

  useEffect(() => {
    const init = () => {
      joService.get(code).then(async (res) => {
        const { result } = res.data;
        // console.log(result);
        setHeader(result[version]);
        setItem_para(result[version].detail);
        setRemark(result[version].remark);

        // console.log(result[version].parametersTreatment);
      });
    };
    init();
  }, [code]);

  return (
    <div className="page-show" id="jo">
      <div className="title-preview">
        <Button
          className="bn-center  bg-blue-400"
          onClick={() => {
            handlePrint();
          }}
          icon={<PiPrinterFill style={{ fontSize: "1.1rem" }} />}
        >
          PRINT
        </Button>
      </div>
      <div className="print-layout-page" ref={pagesRef}>
        {itemChunks.map((chunk, idx) => (
          <div
            key={idx}
            className={`jo-preview-page${idx < itemChunks.length - 1 ? " has-divider" : ""}`}
            style={{ pageBreakAfter: idx < itemChunks.length - 1 ? "always" : "auto" }}
          >
            <PrintComponent
              items={chunk}
              isLastPage={idx === itemChunks.length - 1}
            />
          </div>
        ))}
      </div>
      <div className="hidden">
        <div ref={printRef}></div>
      </div>
    </div>
  );
}

export default JoPrintPreview;
